"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalInformationSaveRequest = void 0;
var enum_1 = require("../../../library/enum");
var PersonalInformationSaveRequest = /** @class */ (function () {
    function PersonalInformationSaveRequest() {
        // 授信流水号
        this.creditNo = '';
        // 姓名
        this.custName = '';
        // 身份证号
        this.idNo = '';
        // 性别
        this.sex = new enum_1.ENUM([{ key: '男', value: '男' }, { key: '女', value: '女' }], '男');
        // 民族
        this.nation = '';
        //出生日期
        this.birthday = new Date();
        //户籍地址
        this.idAddress = '';
        //签发机关
        this.signOrganization = '';
        //身份证有效期起始时间
        this.idValidDateBegin = new Date();
        //身份证有效期结束时间
        this.idValidDateEnd = new Date();
        //户头号
        this.eppId = '';
        //手机号
        this.phoneNo = '';
        //居住省
        this.liveProvince = '';
        //居住市
        this.liveCity = '';
        //居住区
        this.liveArea = '';
        //详细居住地址
        this.liveAddress = '';
        //家庭联系人关系
        this.contactRelation = '';
        //家庭联系人姓名
        this.contactName = '';
        //联系人手机号
        this.contactPhoneNo = '';
        //其它联系人关系
        this.otherContactRelation = '';
        //其它联系人姓名
        this.otherContactName = '';
        //其它联系人手机号
        this.otherContactPhoneNo = '';
        //客户学历
        this.custEducation = '';
        //客户邮箱
        this.custEmail = '';
        //客户QQ号
        this.custQq = '';
    }
    return PersonalInformationSaveRequest;
}());
exports.PersonalInformationSaveRequest = PersonalInformationSaveRequest;
;
//# sourceMappingURL=personalInformationSave.request.js.map